import {STEP_ORDER} from '../../constants';

import {FhsContext} from './actorContext';

export const useFhsActor = FhsContext.useActorRef;

export const useFhs = () => {
  const stepName = FhsContext.useSelector((s) => s.value);
  const formData = FhsContext.useSelector((s) => s.context.formData);
  const errors = FhsContext.useSelector((s) => s.context.errors);
  const touched = FhsContext.useSelector((s) => s.context.touched);
  const canContinue = FhsContext.useSelector((s) => s.can({type: 'NEXT'}));

  const stepIndex = STEP_ORDER.indexOf(stepName);
  const isFirst = stepIndex === 0;
  const isLast = stepIndex === STEP_ORDER.length - 1;

  return {
    stepName,
    formData,
    errors,
    touched,
    canContinue,
    stepIndex,
    isFirst,
    isLast,
  };
};
